export default function isEditableRoute(track: Track) {
    // Recorded track
    if (track.properties.track_type !== 'route') return false;
    // New route
    if (
        track.properties.isLocallyCreated &&
        track.isGeometryLoaded &&
        !track.unmodifiedLine &&
        Object.values(track.points).length === 0
    )
        return true;
    // Imported route
    if (track.isGeometryLoaded && track.unmodifiedLine && Object.values(track.points).length === 0)
        return false;
    return true;
}
